import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, TransitionGroup as _TransitionGroup, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "date-selector-card__inputs row q-col-gutter-md" }
const _hoisted_2 = { class: "date-selector-card__actions" }
const _hoisted_3 = {
  style: {"font-size":"15px","margin-bottom":"5px"},
  class: "text-center"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "col-12 text-center" }, "Проживающие", -1)
const _hoisted_5 = { class: "col-auto" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "icon-container" }
const _hoisted_9 = { class: "icon-down" }
const _hoisted_10 = { class: "col-12 row justify-between" }
const _hoisted_11 = { class: "col-12 q-mb-md q-px-md" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_VueDatePicker = _resolveComponent("VueDatePicker")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_menu = _resolveComponent("q-menu")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_dialog = _resolveComponent("q-dialog")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_q_card, {
      class: "date-selector-card",
      onClick: _cache[1] || (_cache[1] = ($event: any) => {
        if (_ctx.step == -1) {
          _ctx.dateSelectorDialog = true;
        }
      })
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_q_input, {
            class: "date-selector-card__input col-xs-12 col-sm-6 col-md-3",
            outlined: "",
            dense: "",
            "bg-color": "white",
            readonly: "",
            "model-value": _ctx.formattedSelectedDate.from,
            label: "Дата заезда"
          }, {
            prepend: _withCtx(() => [
              _createVNode(_component_q_icon, {
                name: "event_available",
                color: "primary"
              })
            ]),
            _: 1
          }, 8, ["model-value"]),
          _createVNode(_component_q_input, {
            class: "date-selector-card__input col-xs-12 col-sm-6 col-md-3",
            outlined: "",
            dense: "",
            "bg-color": "white",
            readonly: "",
            "model-value": _ctx.formattedSelectedDate.to,
            label: "Дата выезда"
          }, {
            prepend: _withCtx(() => [
              _createVNode(_component_q_icon, {
                name: "event_busy",
                color: "primary"
              })
            ]),
            _: 1
          }, 8, ["model-value"]),
          _createVNode(_component_q_input, {
            class: "date-selector-card__input col-xs-12 col-sm-6 col-md-3",
            outlined: "",
            dense: "",
            "bg-color": "white",
            readonly: "",
            "model-value": _ctx.formattedSelectedDate.days,
            label: 
            _ctx.formateDayNight(_ctx.formattedSelectedDate.days).charAt(0).toUpperCase() +
            _ctx.formateDayNight(_ctx.formattedSelectedDate.days).slice(1) +
            ' пребывания'
          
          }, {
            prepend: _withCtx(() => [
              _createVNode(_component_q_icon, {
                name: "hotel",
                color: "primary"
              })
            ]),
            _: 1
          }, 8, ["model-value", "label"]),
          _createVNode(_component_q_input, {
            class: "date-selector-card__input col-xs-12 col-sm-6 col-md-3",
            outlined: "",
            dense: "",
            "bg-color": "white",
            readonly: "",
            "model-value": _ctx.rooms.length,
            label: "Номеров"
          }, {
            prepend: _withCtx(() => [
              _createVNode(_component_q_icon, {
                name: "meeting_room",
                color: "primary"
              })
            ]),
            _: 1
          }, 8, ["model-value"])
        ]),
        _createElementVNode("div", _hoisted_2, [
          (_ctx.step == -1)
            ? (_openBlock(), _createBlock(_component_q_btn, {
                key: 0,
                class: "date-selector-card__btn",
                unelevated: "",
                color: "primary",
                icon: "calendar_month"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Выбрать даты")
                ]),
                _: 1
              }))
            : (_openBlock(), _createBlock(_component_q_btn, {
                key: 1,
                onClick: _cache[0] || (_cache[0] = ($event: any) => {
            _ctx.dateSelectorDialog = true;
            _ctx.step = -1;
          }),
                class: "date-selector-card__btn",
                unelevated: "",
                color: "primary",
                icon: "edit_calendar"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Изменить даты")
                ]),
                _: 1
              }))
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_q_dialog, {
      modelValue: _ctx.dateSelectorDialog,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.dateSelectorDialog) = $event)),
      class: "mb-12"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card, { class: "row justify-center q-pt-md" }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              _createTextVNode(" Дата заезда "),
              _createVNode(_component_VueDatePicker, {
                modelValue: _ctx.selectedDateRange[0],
                "onUpdate:modelValue": [
                  _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedDateRange[0]) = $event)),
                  _cache[3] || (_cache[3] = ($event: any) => (_ctx.changeDateFrom()))
                ],
                format: _ctx.formattedSelectedDate.from,
                clearable: false,
                "auto-apply": "",
                "min-date": new Date(),
                "enable-time-picker": false,
                locale: "ru"
              }, null, 8, ["modelValue", "format", "min-date"])
            ]),
            _createElementVNode("div", null, [
              _createTextVNode(" Дата выезда "),
              _createVNode(_component_VueDatePicker, {
                modelValue: _ctx.selectedDateRange[1],
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selectedDateRange[1]) = $event)),
                format: _ctx.formattedSelectedDate.to,
                clearable: false,
                "auto-apply": "",
                "min-date": _ctx.addDays(_ctx.selectedDateRange[0], _ctx.config.calc_night ? 1 : 0),
                "max-date": _ctx.addDays(_ctx.selectedDateRange[0], _ctx.config.max_days),
                "enable-time-picker": false,
                locale: "ru"
              }, null, 8, ["modelValue", "format", "min-date", "max-date"])
            ]),
            _createVNode(_component_q_input, {
              readonly: "",
              modelValue: _ctx.formattedSelectedDate.days,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formattedSelectedDate.days) = $event)),
              label: 
            _ctx.formateDayNight(_ctx.formattedSelectedDate.days).charAt(0).toUpperCase() +
            _ctx.formateDayNight(_ctx.formattedSelectedDate.days).slice(1) +
            ' пребывания'
          
            }, null, 8, ["modelValue", "label"]),
            (!_ctx.small)
              ? (_openBlock(), _createBlock(_component_VueDatePicker, {
                  key: 0,
                  style: {"--dp-background-color":"#007748"},
                  class: "col-auto",
                  "multi-calendars": "",
                  modelValue: _ctx.selectedDateRange,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.selectedDateRange) = $event)),
                  inline: "",
                  "auto-apply": "",
                  range: "",
                  "partial-range": false,
                  "min-range": _ctx.config.calc_night ? 1 : 0,
                  "max-range": _ctx.config.max_days,
                  "min-date": new Date(),
                  "enable-time-picker": false,
                  "month-change-on-scroll": false,
                  locale: "ru"
                }, null, 8, ["modelValue", "min-range", "max-range", "min-date"]))
              : _createCommentVNode("", true),
            _createVNode(_TransitionGroup, {
              name: "rooms",
              tag: "r"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rooms, (room, roomIdx) => {
                  return (_openBlock(), _createBlock(_component_q_card, {
                    class: "rooms-item",
                    id: 'room-' + roomIdx,
                    bordered: "",
                    style: {"margin":"10px"},
                    key: roomIdx
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_card_section, { class: "row justify-center" }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_3, " Номер " + _toDisplayString(roomIdx + 1), 1),
                          _hoisted_4,
                          _createElementVNode("div", _hoisted_5, [
                            _createVNode(_TransitionGroup, {
                              name: "icons",
                              tag: "p"
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(room.search.adults, (adult) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    onClick: ($event: any) => {if (room.search.adults > 1) room.search.adults--;},
                                    class: "icons-item",
                                    key: 'a' + adult,
                                    style: {"font-size":"40px"}
                                  }, [
                                    _createElementVNode("div", {
                                      class: _normalizeClass({ 'icon-container': room.search.adults > 1 })
                                    }, [
                                      _createVNode(_component_q_icon, {
                                        style: {"color":"rgba(255, 0, 0, 0.664)"},
                                        class: "icon-adult-up",
                                        name: "fa-solid fa-times"
                                      }),
                                      _createVNode(_component_q_icon, {
                                        class: "icon-down",
                                        name: "fa-solid fa-person"
                                      })
                                    ], 2)
                                  ], 8, _hoisted_6))
                                }), 128)),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(room.search.children, (child, i) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    onClick: ($event: any) => (room.search.children.splice(i, 1)),
                                    class: "text-center icons-item",
                                    key: child
                                  }, [
                                    _createElementVNode("div", _hoisted_8, [
                                      _createVNode(_component_q_icon, {
                                        style: {"font-size":"20px","color":"rgba(255, 0, 0, 0.664)"},
                                        class: "icon-child-up",
                                        name: "fa-solid fa-times"
                                      }),
                                      _createElementVNode("div", _hoisted_9, [
                                        _createElementVNode("div", null, _toDisplayString(child), 1),
                                        _createVNode(_component_q_icon, {
                                          style: {"font-size":"25px"},
                                          name: "fa-solid fa-child"
                                        })
                                      ])
                                    ])
                                  ], 8, _hoisted_7))
                                }), 128))
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _createElementVNode("div", _hoisted_10, [
                            _createVNode(_component_q_btn, {
                              style: {"font-size":"11px"},
                              class: "col-5",
                              onClick: ($event: any) => (room.search.adults++)
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" Добавить взрослого (" + _toDisplayString(_ctx.config.max_child_age + 1) + "+) ", 1)
                              ]),
                              _: 2
                            }, 1032, ["onClick"]),
                            _createVNode(_component_q_btn, {
                              style: {"font-size":"11px"},
                              class: "col-5",
                              label: "Добавить ребенка"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_q_menu, {
                                  fit: "",
                                  anchor: "bottom left",
                                  self: "top left"
                                }, {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.config.max_child_age - _ctx.config.min_child_age + 1, (n, i) => {
                                      return _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                                        onClick: ($event: any) => (room.search.children.push(i + _ctx.config.min_child_age)),
                                        clickable: "",
                                        key: i
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_q_item_section, null, {
                                            default: _withCtx(() => [
                                              _createTextVNode("Ребенок " + _toDisplayString(_ctx.formateAge(i + _ctx.config.min_child_age)), 1)
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ]),
                                        _: 2
                                      }, 1032, ["onClick"])), [
                                        [_directive_close_popup]
                                      ])
                                    }), 128))
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          (_ctx.rooms.length > 1)
                            ? (_openBlock(), _createBlock(_component_q_btn, {
                                key: 0,
                                style: {"position":"absolute","top":"10px","right":"10px"},
                                size: "sm",
                                flat: "",
                                rounded: "",
                                onClick: ($event: any) => (_ctx.rooms.splice(roomIdx, 1))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(" Удалить номер ")
                                ]),
                                _: 2
                              }, 1032, ["onClick"]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1032, ["id"]))
                }), 128))
              ]),
              _: 1
            }),
            _createVNode(_component_q_btn, {
              size: "sm",
              flat: "",
              style: {"margin-bottom":"10px"},
              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.addRoomForSearch()))
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Добавить еще один номер ")
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_q_btn, {
                style: {"width":"100%"},
                color: "primary",
                onClickOnce: _cache[8] || (_cache[8] = ($event: any) => (_ctx.findRooms()))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Найти номера")
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}